import { FC, useMemo } from 'react';

import { CMSDescription } from '@/api/cms/base';
import {
  getDefaultSection,
  getMatchingSection,
} from '@/helpers/userAccessSection';
import { useCommonStore } from '@/store/commonStore';

import { ScPageDescription } from './styled';

interface PageDescriptionProps {
  sections: CMSDescription[];
  className?: string;
}

export const CmsPageDescription: FC<PageDescriptionProps> = ({
  sections,
  className,
}) => {
  const user = useCommonStore.use.user();

  const pageDescriptionText = useMemo(() => {
    const section = getMatchingSection(sections, user);
    return section
      ? section.descriptionText
      : getDefaultSection(sections)?.descriptionText;
  }, [sections, user]);

  return pageDescriptionText ? (
    <ScPageDescription
      className={className}
      dangerouslySetInnerHTML={{ __html: pageDescriptionText }}
    />
  ) : null;
};
